import { useEffect } from "react";
import TagManager from "react-gtm-module";
import SEO from "../SEO";
import styles from "./GreenRestrooms.module.css";

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "שירותים ירוקים לעסק — משתנות ללא מים | Waterless",
  description:
    "שירותים ירוקים וחסכוניים לעסק: פתרון ירוק לשירותי משרדים ומוסדות באמצעות משתנות ללא מים, ללא חשמל וללא ריחות.",
  url: "https://waterless.co.il/שירותים-ירוקים",
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "דף הבית", item: "https://waterless.co.il/" },
    {
      "@type": "ListItem",
      position: 2,
      name: "שירותים ירוקים לעסק",
      item: "https://waterless.co.il/שירותים-ירוקים",
    },
  ],
};

const benefits = [
  { t: "שירותים ללא מים — פתרון ירוק", d: "משתנות שאינן צורכות מים כלל להדחה, וחוסכות עד 100,000 ליטר מים בשנה לכל יחידה." },
  { t: "שירותים חסכוניים לעסק ירוק", d: "הורדת עלויות המים, הביוב והתחזוקה — חיסכון שמחזיר את ההשקעה תוך חודשים בלבד." },
  { t: "פתרון ירוק לשירותי משרדים", d: "מתאים למשרדים, מוסדות ומבני ציבור, כולל מבנים ירוקים העומדים בתקני LEED." },
  { t: "שירותים מתקדמים ללא ריחות", d: "סיפון ונוזל איטום חוסמים ריחות הרמטית, ללא חשמל וללא כימיקלים מזיקים, כשר לשבת." },
];

function GreenRestrooms() {
  useEffect(() => {
    window.scrollTo(0, 0);
    TagManager.dataLayer({
      dataLayer: { event: "pageview", pagePath: "/שירותים-ירוקים", pageTitle: "שירותים ירוקים לעסק" },
    });
  }, []);

  return (
    <main className={`container px-3 px-md-5 ${styles.page}`}>
      <SEO
        title="שירותים ירוקים לעסק — שירותים ללא מים וחסכוניים | ווטרלס (Waterless) ישראל"
        description="שירותים ירוקים לעסק: שירותים ללא מים, חסכוניים וללא ריחות. פתרון ירוק לשירותי משרדים ומוסדות מבית Waterless — חיסכון עד 100,000 ליטר מים בשנה. בקשו הצעת מחיר."
        path="/שירותים-ירוקים"
        structuredData={[webPageSchema, breadcrumbSchema]}
      />
      <p className={styles.eyebrow}>אור ירוק לעסק ירוק</p>
      <h1 className={styles.title}>שירותים ירוקים לעסק — פתרון ללא מים</h1>
      <p className={styles.tagline}>שירותים מתקדמים, אור לעסק</p>
      <p className={styles.lead}>
        שירותים ירוקים הם הצעד הראשון של כל עסק שרוצה לחסוך במים ובהוצאות תפעול. משתנות ללא מים של
        Waterless מספקות שירותים מתקדמים, חסכוניים וללא ריחות — פתרון ירוק לשירותי משרדים, מוסדות
        ומבני ציבור בכל הארץ.
      </p>
      <ul className={styles.benefits}>
        {benefits.map((b) => (
          <li key={b.t} className={styles.benefit}>
            <h3>{b.t}</h3>
            <p>{b.d}</p>
          </li>
        ))}
      </ul>
      <a className={styles.cta} href="/contact" aria-label="קבל הצעת מחיר לשירותים ירוקים">
        קבל הצעת מחיר
      </a>
      <p className={styles.links}>
        רוצים להשוות טכנולוגיות?{" "}
        <a href="/השוואת-משתנות-ללא-מים">השוואת משתנות ללא מים</a> · קראו על{" "}
        <a href="/article/שירותים-חסכוניים-במים-לעסק-ירוק">שירותים חסכוניים לעסק ירוק</a>.
      </p>
    </main>
  );
}

export default GreenRestrooms;
